import { triggerEvent } from '../helpers';

const Hammer = require('hammerjs');

const sliderInit = () => {
  const moveSlides = (num, slider) => {
    const slides = Array.from(slider.children);
    let { slidesVisible } = slider.dataset;

    if (window.innerWidth < 1024 && slider.dataset.slidesVisibleMobile) {
      slidesVisible = slider.dataset.slidesVisibleMobile;
    }
    const start = slidesVisible * num;
    const end = slidesVisible * (num + 1);
    slides.forEach(element => {
      element.classList.remove('is-active');
    });
    for (let i = start; i < end; i++) {
      if (slides[i]) {
        slides[i].classList.add('is-active');
      }
    }
  };

  const slider = document.querySelectorAll('.js-slider');
  slider.forEach(element => {
    const sliderArea = new Hammer(element);
    const slides = element.children;
    let interval = null;

    sliderArea.on('swipeleft swiperight', event => {
      const pages = element.parentNode.querySelectorAll('.c-slider__page');
      const current = [...pages].indexOf(
        element.parentNode.querySelector('.c-slider__page.is-active'),
      );
      let nextIndex = 0;
      clearInterval(interval);
      if (event.type == 'swipeleft') {
        nextIndex = (current + 1) % pages.length;
      }
      if (event.type == 'swiperight') {
        nextIndex = current - 1;

        if (nextIndex < 0) {
          nextIndex = [...pages].length - 1;
        }
      }
      element.parentNode.querySelectorAll('li').forEach(element => {
        element.classList.remove('is-active');
      });
      pages[nextIndex].classList.add('is-active');
      moveSlides(nextIndex, element);
    });

    if (slides.length) {
      if (element.parentNode.querySelectorAll('.js-slider-pager li').length) {
        element.parentNode
          .querySelectorAll('.js-slider-pager li')
          .forEach(liElem => {
            liElem.remove();
          });
      }
      const { slidesVisible, slidesVisibleMobile, sliderType } = element.dataset;
      const createPager = (num) => {
        element.parentNode.querySelector('.js-slider-pager').innerHTML = "";

        for (let i = 0; i < slides.length / num; i++) {
          const li = document.createElement('li');
          li.classList.add('c-slider__page');
          if (i == 0) {
            li.classList.add('is-active');
          }
          li.addEventListener('click', e => {
            if (e.isTrusted) {
              clearInterval(interval);
            }
            element.parentNode.querySelectorAll('li').forEach(element => {
              element.classList.remove('is-active');
            });
            e.target.classList.add('is-active');
            moveSlides(i, element);
          });
          if (element.parentNode.querySelector('.js-slider-pager')) {
            element.parentNode
              .querySelector('.js-slider-pager')
              .appendChild(li);
          }
        }
      };
      const initPager = () => {
        if (slidesVisibleMobile) {
          window.addEventListener('resize', () => {
            if (window.innerWidth < 1024) {
              createPager(slidesVisibleMobile);
            } else {
              createPager(slidesVisible);
            }
          });
        } else {
          createPager(slidesVisible);
        }
        triggerEvent(window, 'resize');
      };
      const automaticSlideMoves = () => {
        interval = setInterval(() => {
          const pages = element.parentNode.querySelectorAll('.c-slider__page');
          const current = [...pages].indexOf(
            element.parentNode.querySelector('.c-slider__page.is-active'),
          );
          const nextIndex = (current + 1) % pages.length;
          element.parentNode
            .querySelector(`.c-slider__page:nth-child(${nextIndex + 1})`)
            .click();
        }, 6000);
      };
      switch (sliderType) {
        case 'rotator':
          for (let i = 0; i < slidesVisible; i++) {
            slides[i].classList.add('is-active');
          }
          initPager();
          automaticSlideMoves();
          break;
        case 'standard':
          initPager();
          automaticSlideMoves();
          break;
        default:
          break;
      }
    }
  });
};

export default sliderInit;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/slider.js